import React from 'react'
import { Grid, Typography } from '@mui/material'

interface StatesDisplayProps {
  states: Record<string, string[] | any>
}

const StatesDisplay: React.FC<StatesDisplayProps> = ({ states }) => {
  if (Object.entries(states).length === 0) {
    return null
  } else {
    return (
      <Grid container>
        {
          Object.entries(states)
            .map(([key, values]) => {
              return (
                <Grid
                  item xs={4}
                  key={key}
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    ':hover': {
                      backgroundColor: 'secondary.main'
                    }
                  }}
                  gap={1}
                  paddingX={1}
                >
                  <Typography>
                    {key}
                  </Typography>
                  <Typography>
                    {
                      Array.isArray(values)
                        ? (values as string[]).reduce((previousValue, currentValue) => previousValue.concat(', ' + currentValue))
                        : values
                    }
                  </Typography>
                </Grid>
              )
            })
        }
      </Grid>
    )
  }
}

export default StatesDisplay
